import React from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Field } from 'react-final-form';
import Stack from '@mui/material/Stack';
import DropDownList from 'components/DropDownList';
import { getCardValues } from 'lib/product';
import ToggleButtonGroup from 'components/ToggleButtonGroup';
import FormSection from 'components/Layout/FormSection';
import MultiCardDisplay from './stepComponents/MultiCardDisplay';
import { CardConfigurerStepProps } from '../CardConfigurerForm';
import { isOpenLoopCard, isCardDotGiftCard } from '../configurerFlags';
import { RECIPIENT_COUNT_MULTIPLE, RECIPIENT_COUNT_SINGLE } from 'utilities/constants';
import PanelLayout from './stepComponents/PanelLayout';
// import debug from 'debug';
// const d = debug('cardValue');

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      '&[hidden]': {
        display: 'none',
      },
    },
  }),
  { name: 'CardValue' },
);

const CardValue: React.FC<CardConfigurerStepProps> = ({ step, index, product, values, steps, submitButton }) => {
  const classes = useStyles();

  const cardImageContent = <MultiCardDisplay defaultProductHandle={product.handle} values={values} step={step} steps={steps} showLogo={!!values.cardCustomImage && !isCardDotGiftCard(product)} />;

  const formContent = (
    <Stack sx={{ maxWidth: '400px' }}>
      <FormSection sx={{ alignItems: { xs: 'center', md: 'flex-start' } }}>
        <Field name="recipientCount" defaultValue={isOpenLoopCard(product) ? RECIPIENT_COUNT_MULTIPLE : RECIPIENT_COUNT_SINGLE}>
          {({ input: { value, onChange } }) => (
            <ToggleButtonGroup
              fullWidth={false}
              name="recipientCount"
              items={[
                {
                  label: 'Single Recipient',
                  value: 'one',
                  helperText: 'Send one or more cards to a single recipient',
                },
                {
                  label: 'Multiple Recipients',
                  value: 'multiple',
                  helperText: 'Send multiple cards to one or more recipients',
                },
              ]}
              value={value}
              onChange={(event, newValue) => {
                newValue ? onChange(newValue) : onChange(value);
              }}
            />
          )}
        </Field>
        <Field name="cardValue">
          {({ input: { value, onChange } }) => (
            <DropDownList
              name="cardValue"
              items={getCardValues(product, values.cardMedium)}
              value={value}
              onChange={(event) => {
                onChange(+event.target.value);
              }}
            />
          )}
        </Field>
      </FormSection>
    </Stack>
  );

  return (
    <div className={classes.root} hidden={step !== index}>
      <PanelLayout value={step} index={index} title="How much would you like to add?" cardImageContent={cardImageContent} formContent={formContent} buttonsContent={submitButton} />
    </div>
  );
};

export default CardValue;
